<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path fill="currentColor" d="M7.5 12.667V8.5H3.333v-1H7.5V3.333h1V7.5h4.167v1H8.5v4.167h-1Z" />
    </svg>
</template>

<script setup lang="ts">
type PlusIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<PlusIconProps>();
</script>
